import { READER_BASE_URL } from "./global";

/**
 * Prefixes an absolute path with the reader's base URL when the app is served
 * under a path prefix. window.READER_BASE_URL is injected
 * by the cf proxy worker (see modules/cf-proxy-worker/spa.ts)
 */
export const readerPath = (path: string): string => READER_BASE_URL + path;
